import type { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { ArcheGamesBody, gamesArcheSeo } from '@fias/public-site-ui';
import { ApiError } from '@/lib/api';
import { siteOrigin, usePageHead } from '@/lib/document-head';
import { useGameArche } from '../hooks/useGamesCatalog';
import { GamesLoadFailed, GamesLoading } from './GamesStatus';
import { GamesNotFoundPage } from './GameDetailPage';

/** Every game in one arche: `/a/games/from/<arche>` (its slug, or its id). */
export function GameArchePage(): ReactElement {
  const { archeKey = '' } = useParams();
  const arche = useGameArche(archeKey);
  const seo = arche.data ? gamesArcheSeo(arche.data, siteOrigin() ?? '') : null;
  usePageHead(
    seo
      ? {
          title: seo.title,
          description: seo.description,
          canonicalPath: seo.canonicalPath,
          jsonLd: siteOrigin() ? seo.jsonLd : [],
        }
      : null,
  );

  if (arche.error instanceof ApiError && arche.error.status === 404) {
    return <GamesNotFoundPage />;
  }
  if (arche.isError && !arche.data) {
    return <GamesLoadFailed what="These games" onRetry={() => void arche.refetch()} />;
  }
  if (!arche.data) return <GamesLoading />;
  return <ArcheGamesBody data={arche.data} />;
}
